package com.bulut.mecitogullari.data.model

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

/**
 * Firestore-safe Long: on Kotlin/JS a Long is a custom object the Firestore
 * JS SDK rejects, so epoch-millis fields are stored as numbers (Double).
 * Exact for |value| < 2^53 — far beyond any epoch-millis timestamp.
 */
object LongAsDoubleSerializer : KSerializer<Long> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("LongAsDouble", PrimitiveKind.DOUBLE)

    override fun serialize(encoder: Encoder, value: Long) =
        encoder.encodeDouble(value.toDouble())

    override fun deserialize(decoder: Decoder): Long =
        decoder.decodeDouble().toLong()
}
